{
  "main": {
    "title": "Account Settings"
  },
  "geslo": {
    "title": "Change User Password",
    "description": "Update your password for increased security",
    "labels": {
      "staroGeslo": "Old password",
      "novoGeslo": "New password",
      "potrditevGesla": "Confirm new password"
    },
    "buttons": {
      "ponastaviGeslo": "Reset password"
    }
  },
  "podatki": {
    "title": "Pilot information",
    "description": "Edit your information (Address, phone number, email)"
  },
  "podpis": {
    "title": "Digital Signature",
    "description": "Add your signature for invoices"
  },
  "auth": {
    "title": "2FA Authentication",
    "description": "2FA authentication settings"
  },
  "language": {
    "title": "Language",
    "description": "User interface language settings"
  },
  "buttons": {
    "zakljuci": "Finish editing"
  },
  "bracun": {
    "title": "Delete Account",
    "description": "Deleting/Deactivating an Account"
  },
  "obvestila": {
    "podpisDodan": "Signature added to the invoice. The signature will be visible after you log in again.",
    "gesloSpremenjeno": "Password successfully changed. You will be logged out automatically in a few seconds...",
    "gesloNiUjema": "Passwords do not match",
    "napacnoGeslo": "The old password entered is incorrect!",
    "napakaPosodabljanja": "Error updating data",
    "napakaBranja": "Error reading data"
  }
}